var _rect, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceContent0102(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60.0001,
    fill: "#FABB00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2815 43.1766C31.1075 44.6295 28.8925 44.6295 27.7185 43.1766L21.1104 34.9991C17.1718 30.1251 17.8926 22.9884 22.7263 19.0004V19.0004C26.9491 15.5164 33.0495 15.5164 37.2724 19.0001V19.0001C42.1067 22.9882 42.8279 30.1255 38.889 34.9999L32.2815 43.1766Z",
    stroke: "#1B1C1E",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 27,
    r: 4,
    stroke: "#1B1C1E",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceContent0102);
export default __webpack_public_path__ + "static/media/service-content01-02.0ad6c3a5a0cd1ad1cca0ad8d88097f7b.svg";
export { ForwardRef as ReactComponent };